export const GET_TASK_POTENTIAL_USERS = 'GET_TASK_POTENTIAL_USERS';
export const GET_TASK_POTENTIAL_USERS_SUCCESS = 'GET_TASK_POTENTIAL_USERS_SUCCESS';
export const GET_TASK_POTENTIAL_USERS_FAILURE = 'GET_TASK_POTENTIAL_USERS_FAILURE';
